import React from 'react';
import { CTASection } from '../../components/CTASection';
import { Sticker } from 'lucide-react';
export function Decals() {
  return <div className="flex flex-col w-full" data-id="element-1249">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-wh-teal to-teal-600 py-20" data-id="element-1250">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1251">
          <div className="flex justify-center mb-6" data-id="element-1252">
            <Sticker className="w-16 h-16 text-white" data-id="element-1253" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-1254">
            Custom Decals
          </h1>
          <p className="text-xl text-white/90 max-w-2xl mx-auto" data-id="element-1255">
            High-quality custom decals designed to make your mark
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white" data-id="element-1256">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1257">
          <div className="prose prose-lg max-w-none text-gray-700 space-y-6" data-id="element-1258">
            <p data-id="element-1259">
              At Wear Haus Designs, we create custom decals that help you
              express your brand, personality, or message with style. Our decals
              are printed on high-quality, durable materials designed to look
              great and last.
            </p>
            <p data-id="element-1260">
              Whether you need something simple or complex, our team works with
              you to bring your vision to life. From design to production,
              everything is handled in-house for quality control and quick
              turnaround times.
            </p>
            <p data-id="element-1261">
              With fully customizable options for size, shape, and design, we
              make it easy to create decals that are uniquely yours. Ready to
              get started? Contact us today to discuss your project!
            </p>
          </div>

          {/* CTA Box */}
          <div className="mt-16 bg-gradient-to-br from-wh-pink to-pink-600 rounded-2xl p-12 text-center text-white" data-id="element-1262">
            <Sticker className="w-16 h-16 mx-auto mb-6" data-id="element-1263" />
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-1264">
              Let's Create Something Great
            </h2>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto" data-id="element-1265">
              Ready to bring your decal ideas to life? Contact us today for a
              quote.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1266">
              <a href="/Contact" className="inline-flex items-center justify-center px-8 py-4 bg-white text-wh-pink font-bold rounded-lg hover:bg-gray-100 transition-colors" data-id="element-1267">
                Get a Quote
              </a>
              <a href="/services" className="inline-flex items-center justify-center px-8 py-4 bg-wh-yellow text-gray-900 font-bold rounded-lg hover:bg-yellow-400 transition-colors" data-id="element-1268">
                View All Services
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <CTASection data-id="element-1269" />
    </div>;
}